import styled from "styled-components"
// import overviewImage from "../../../../app/assets/img/overview-background.jpg"
import overviewImage from "../../../../app/assets/img/luxury-living-suites.jpg"

export const OverviewContainer = styled.section`
  padding: ${({ theme }) => theme.spacing.xxl} ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.backgroundSecondary};
  width: 100%;
  background-image: url(${overviewImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing.lg};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.md};
  }
`

export const TextContent = styled.div`
  text-align: left;
  max-width: 40%;
  margin-bottom: ${({ theme }) => theme.spacing.xxl};
  padding-left: 1.2rem;
  padding-top: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: ${({ theme }) => theme.spacing.xl};
    max-width: 100%;
  }
`

export const SectionTitle = styled.h2`
  font-family: "Fraunces", serif;
  color: white;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  line-height: 1.3;
  font-size: 3.3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 2.6rem;
    line-height: 1.2;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 2rem;
  }
`

export const SectionSubtitle = styled.p`
  font-family: ${({ theme }) => theme.typography.fontFamily.body};
  font-size: 1.4rem;
  font-weight: 400;
  color: white;
  line-height: 1.5;
  font-style: italic;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.typography.fontSize.md};
    line-height: 1.4;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.typography.fontSize.lg};
  }
`

export const Overlay = styled.div`
  ${({ top, bottom, left, right }) => `
    top: ${top || "auto"};
    bottom: ${bottom || "auto"};
    left: ${left || "auto"};
    right: ${right || "auto"};
  `}
  position: absolute;
  background-color: rgba(255, 255, 255, 1);
  color: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.primary};
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.lg};
  border-radius: ${({ theme }) => theme.components.borderRadius.medium};
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px); // Glass effect
  max-width: 300px;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.015);
    box-shadow: ${({ theme }) => theme.components.boxShadow.large};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    // Adjust breakpoint if needed
    padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
    max-width: 250px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.md};
    max-width: 180px;
    background-color: rgba(255, 255, 255, 0.9);
    /* background: rgba(255, 255, 255, 0.9);
    color: ${({ theme }) => theme.primary}; */

    &:last-child {
      top: 45%;
      right: 5%;
      max-width: 220px;
    }
  }
`

export const OverlayTitle = styled.h4`
  font-family: ${({ theme }) => theme.typography.fontFamily.headings};
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  margin: 0 0 ${({ theme }) => theme.spacing.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  line-height: 1.3;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.typography.fontSize.md};
    line-height: 1.2;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
  }
`

export const OverlayText = styled.p`
  font-family: ${({ theme }) => theme.typography.fontFamily.body};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.regular};
  line-height: 1.4;
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
    line-height: 1.3;
  }
`
